import { combineReducers } from 'redux'
import errorHandlerReducer from './errorHandlerReducer';
import repositoryReducer from './repositoryReducer';
import { uiReducer }  from './uiReducer';

export const mainReducer = combineReducers({
    repository: repositoryReducer,
    error: errorHandlerReducer,
    ui: uiReducer,

})